import { AxiosPromise } from "axios";
import { BaseService, Service } from "/@/cool";
@Service("team")
class Team extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["bindGroupRejectSetting"] =
			prefix + "bindGroupRejectSetting";
	}
	add(data: any) {
		return this.request({
			url: "/add",
			method: "POST",
			data
		});
	}
	deleteTeam(data: any) {
		return this.request({
			url: "/delete",
			method: "POST",
			data
		});
	}
	bindGroupRejectSetting(data: any) {
		return this.request({
			url: "/bindGroupRejectSetting",
			method: "POST",
			data
		});
	}
}
export default Team;
